import L from 'react-loadable'
import AuthLoader from '../AuthLoader'

const Loadable = opts =>
  L({
    loading: AuthLoader,
    delay: 300,
    ...opts
  })

export default Loadable
